import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"
import _imports_0 from '../assets/lef.svg'
import _imports_1 from '../assets/max.svg'


const _hoisted_1 = { class: "bubble-container" }
const _hoisted_2 = { class: "bubble-contents" }
const _hoisted_3 = { class: "locales" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src", "title"]
const _hoisted_6 = {
  key: 0,
  src: _imports_0,
  width: "80",
  height: "80",
  class: "appicon",
  alt: "LEF"
}
const _hoisted_7 = {
  key: 1,
  src: _imports_1,
  width: "80",
  height: "80",
  class: "appicon",
  alt: "MAX"
}
const _hoisted_8 = { class: "slot" }

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from '@/store';
import { SSOLocale, supportedLocales } from '@/locale';
import Cookies from 'js-cookie';



export default /*@__PURE__*/_defineComponent({
  __name: 'Bubble',
  setup(__props) {

const globalI18n = useI18n({ useScope: 'global' });
const i18n = useI18n();
const { t } = i18n;

const store = useStore();

const visibleLocales = computed<Array<SSOLocale>>(() =>
{
  const currentLocale = globalI18n.locale.value;
  return supportedLocales.filter(l => l.iso !== currentLocale);
});


function switchLocale(locale: SSOLocale)
{
  Cookies.set('SSOLocale', locale.iso);
  globalI18n.locale.value = locale.iso;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleLocales.value, (locale) => {
          return (_openBlock(), _createElementBlock("a", {
            key: locale.iso,
            href: "#",
            onClick: _withModifiers(($event: any) => (switchLocale(locale)), ["prevent"])
          }, [
            _createElementVNode("img", {
              src: locale.flagIcon,
              width: "20",
              height: "20",
              class: "flag",
              title: _unref(t)('locale.tooltip', 0, { locale: locale.iso }),
              alt: ""
            }, null, 8, _hoisted_5)
          ], 8, _hoisted_4))
        }), 128))
      ]),
      (_unref(store).app.value !== 2)
        ? (_openBlock(), _createElementBlock("img", _hoisted_6))
        : _createCommentVNode("", true),
      (_unref(store).app.value === 2)
        ? (_openBlock(), _createElementBlock("img", _hoisted_7))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ])
  ]))
}
}

})